module.exports = __webpack_public_path__ + "static/media/mirror.7926cb33.png";